import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ProjectEvaluationRelationWidget from '../../../widgets/projectEvaluationRelation/projectEvaluationRelationWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getProjectEvaluationRelation,
  searchProjectEvaluationRelation,
  selectProjectEvaluationRelation,
  deleteProjectEvaluationRelation,
} from '../../../redux/actions/attachments'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ProjectEvaluationRelation() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [searchData, setSearchData] = useState([])
  const [code, setCode] = useState('')
  const [name, setName] = useState('')
  const [year, setYear] = useState('')

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectEvaluationRelation(projectId)
      setSchema(_schema)
      setIsEditWidget({
        attachment: _schema.forms?.attachment?.attachFiles?.value.length > 0 ? false : true,
      })

      setShowEditAll(!_schema.forms?.attachment?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = async () => {
    // setIsLoading(true)
    startLoading()
    let searchQueryParam = `projectVersionId=${projectId}`
    if (code) {
      searchQueryParam = `${searchQueryParam}&code=${code}`
    }
    if (name) {
      searchQueryParam = `${searchQueryParam}&name=${name}`
    }
    if (year) {
      searchQueryParam = `${searchQueryParam}&year=${year}`
    }
    searchQueryParam = `${searchQueryParam}&pageSize=5&pageNumber=1`

    try {
      const _res = await searchProjectEvaluationRelation(projectId, searchQueryParam)
      if (_res?.values) {
        console.log(_res.values)
        setSearchData(_res.values)
      }
    } catch (e) {}
    doneLoading()
    // setIsLoading(false)
  }

  const handleSelect = async (index) => {
    try {
      const request = {
        id: `${searchData[index].id}`,
        projectCode: `${searchData[index].projectCode}`,
        projectName: `${searchData[index].projectName}`,
        projectBudget: searchData[index].projectBudget,
        projectYear: `${searchData[index].projectYear}`,
        totalRow: searchData[index].totalRow,
      }
      const res = await selectProjectEvaluationRelation(projectId, request)
      if (res) {
        handleGetSchema()
      }
    } catch (e) {}
  }

  const handleDelete = async (index) => {
    try {
      const res = await deleteProjectEvaluationRelation(
        projectId,
        schema.forms.projectRelation.values[index].id
      )
      if (res == 200) {
        handleGetSchema()
      }
    } catch (e) {}
  }

  const clearSearchData = () => {
    setCode('')
    setName('')
    setYear('')
    setSearchData([])
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={1}>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {/* {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          />
        )} */}

        <>
          <ProjectEvaluationRelationWidget
            showCommandButton={!schema?.disabled}
            isProjectRelationForm={false}
            schema={schema.forms.projectSearch}
            setCode={setCode}
            setName={setName}
            setYear={setYear}
            searchData={searchData}
            onClickSearch={handleSearch}
            onClearSearch={clearSearchData}
            onSelect={handleSelect}
          />
          <ProjectEvaluationRelationWidget
            showCommandButton={!schema?.disabled}
            isProjectRelationForm={true}
            schema={schema.forms.projectRelation}
            onDelete={handleDelete}
          />
        </>
      </SidebarProposal>
    </>
  )
}
